const POSTCODE = { key: 'postcode', name: 'Postcode' }
const ADDRESS = { key: 'address', name: 'Address' }
const PHONE_NUMBER = { key: 'phone_number', name: 'Phone Number' }
const EMAIL = { key: 'email', name: 'Email' }
const IP_ADDRESS = { key: 'ip', name: 'IP Address' }

export const CONTACT_DETAILS = [POSTCODE, ADDRESS, PHONE_NUMBER, EMAIL, IP_ADDRESS]
